import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "components/Inputs";
import { CoinCell } from "components/Table";
import { CloseModalButton } from "components/Buttons";
import BasicModal from "./BasicModal";
// import { bankVariant } from "./DepositModal";
// import { sepaVariant } from "./WithdrawModal";
import type { AvailableTradeOptions } from "helpers/types";

import {
  TopSemiContent,
  ModalHeading,
  CurrencyOptions,
  CurrencyOption,
  CurrencyLine,
  BeingSelected,
  SemiContent,
} from "./styled";

import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import { ReactComponent as CheckIcon } from "assets/icons/check.svg";

export interface ByBitCoinSelectProps {
  options: AvailableTradeOptions[] | null;
  selected?: AvailableTradeOptions;
  isOpen: boolean;
  isDeposit?: boolean;
  isWithdrawal?: boolean;
  onClose: () => void;
  setValue: (val: AvailableTradeOptions) => void;
}

const ByBitCoinSelect: FC<ByBitCoinSelectProps> = ({
  isOpen,
  onClose,
  options = null,
  selected,
  setValue,
  // isDeposit,
  // isWithdrawal,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>("");

  const onSelect = (option: AvailableTradeOptions) => {
    setValue(option);
    onClose();
  };

  const searchedOptions = useMemo(
    () =>
      options?.filter((el) => el.toLowerCase().includes(search.toLowerCase())),
    [search, options]
  );

  return (
    <BasicModal
      isOpen={isOpen}
      onExited={() => setSearch("")}
      onClose={onClose}
      isInsideModal
    >
      <SemiContent>
        <CloseModalButton onClose={onClose} label={t("CLOSE_SELECT")} />
        <TopSemiContent>
          <ModalHeading>{t("SELECT_ASSET")}</ModalHeading>
          <TextInput
            value={search}
            onChange={({ target: { value } }) => setSearch(value)}
            leftIcon={<SearchIcon />}
            placeholder={t("SEARCH")}
          />
        </TopSemiContent>
        <CurrencyOptions>
          {searchedOptions?.map((coin) => (
            <CurrencyOption
              key={coin}
              onClick={() => onSelect(coin)}
              $isSelected={coin === selected}
            >
              <CurrencyLine>
                <CoinCell text={coin} coin={coin} />
              </CurrencyLine>
              <BeingSelected>
                {coin === selected && <CheckIcon />}
              </BeingSelected>
            </CurrencyOption>
          ))}
        </CurrencyOptions>
      </SemiContent>
    </BasicModal>
  );
};

export default ByBitCoinSelect;
